export default function(instance){
    return{
        Get(payload){
            return instance.get('/weather?lat=' + payload.latitude + '&lon=' + payload.longitude + '&appid=8248e361b49b0b2f64a2446570e1e1f4&lang=ru&units=metric');
        },
    }
}
